import {toggleLoader, showInputError} from '../../lib';
import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';

export default class StripeGateway extends PaymentGatewayProcessor {
  processCheckout() {
    return new Promise(async (resolve, reject) => {
      try {
        let formElement = document.querySelector('#payment-form');
        recurly.token(recurlyElements, formElement, (error, token) => {
          if (error) {
            console.error('Stripe error', error);
            toggleLoader(false);
            let cardElement = document.querySelector('#card-element');
            switch (error.code) {
              case 'validation':
                showInputError(cardElement, cartParams.errors.invalid_card);
                break;
              default:
                showInputError(cardElement, error.message);
                break;
            }
            reject(error);
            return;
          }

          resolve(this.checkoutInit());
        });
      } catch (err) {
        throw reject(err);
      }
    });
  }
}
